/* eslint-disable */
import React, { useRef, useCallback, useState, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import location from "../../assets/icon_mapa/location_map.svg";

const initialMarkers = [{ lat: 4.5709, lng: -74.2973 }];

const getZoomLevel = (latitude: any) => (latitude > 10 ? 12 : 12);

const ciudades: any = [
  {
    ciudad: "Colombia",
    coordenadas: { lat: 4.5, lng: -74.0 },
    zoom: 6,
  }, // Centro de Colombia
  {
    ciudad: "Bogotá",
    coordenadas: { lat: 4.61, lng: -74.083 },
    zoom: 12,
  },
  { ciudad: "Armenia", coordenadas: { lat: 4.5339, lng: -75.6813 }, zoom: 12 },
  { ciudad: "Medellín", coordenadas: { lat: 6.2442, lng: -75.5812 }, zoom: 12 },
  { ciudad: "Cali", coordenadas: { lat: 3.4516, lng: -76.532 }, zoom: 12 },
  {
    ciudad: "Villavicencio",
    coordenadas: { lat: 4.1427, lng: -73.6344 },
    zoom: 12,
  },
  { ciudad: "Tunja", coordenadas: { lat: 5.5403, lng: -73.3672 }, zoom: 12 },
  {
    ciudad: "Barranquilla",
    coordenadas: { lat: 10.9685, lng: -74.7813 },
    zoom: 12,
  },
  {
    ciudad: "Cartagena de Indias",
    coordenadas: { lat: 10.391, lng: -75.4794 },
    zoom: 12,
  },
  {
    ciudad: "Santa Marta",
    coordenadas: { lat: 11.2408, lng: -74.1999 },
    zoom: 12,
  },
  {
    ciudad: "Valledupar",
    coordenadas: { lat: 10.4633, lng: -74.1898 },
    zoom: 12,
  },
  {
    ciudad: "Palmira",
    coordenadas: { lat: 3.53944, lng: -76.30363 },
    zoom: 12,
  },
  { ciudad: "Tuluá", coordenadas: { lat: 4.0969, lng: -76.1945 }, zoom: 12 },
  {
    ciudad: "Manizales",
    coordenadas: { lat: 5.0717, lng: -75.5134 },
    zoom: 12,
  },
  { ciudad: "Pereira", coordenadas: { lat: 4.8142, lng: -75.6961 }, zoom: 12 },
  {
    ciudad: "Bucaramanga",
    coordenadas: { lat: 7.1189, lng: -73.1217 },
    zoom: 12,
  },
  {
    ciudad: "Montería",
    coordenadas: { lat: 8.74798, lng: -75.88143 },
    zoom: 12,
  },
  { ciudad: "Cúcuta", coordenadas: { lat: 7.8933, lng: -72.5078 }, zoom: 12 },
  { ciudad: "Chía", coordenadas: { lat: 4.8616, lng: -74.0383 }, zoom: 12 },
  {
    ciudad: "Rionegro",
    coordenadas: { lat: 6.155, lng: -75.373 },
    zoom: 12,
  },
  {
    ciudad: "Itagüí",
    coordenadas: { lat: 6.1846, lng: -75.5994 },
    zoom: 12,
  },
  { ciudad: "Pasto", coordenadas: { lat: 1.2133, lng: -77.2839 }, zoom: 12 },
  { ciudad: "Neiva", coordenadas: { lat: 2.9706, lng: -75.3205 }, zoom: 12 },
  { ciudad: "Ibagué", coordenadas: { lat: 4.4384, lng: -75.2024 }, zoom: 12 },
];

interface ContenidoMapaProps {
  ciudad: any;
  selectedConcesionarios: any; // Define el tipo para selectedConcesionarios
  mylocation: any;
  setCiudad: any;
}

declare const window: any;

const ContenidoMapaComponent: React.FC<ContenidoMapaProps> = ({
  ciudad,
  selectedConcesionarios,
  mylocation,
  setCiudad,
}) => {
  const mapRef = useRef<google.maps.Map | null>(null);
  const [center, setCenter] = useState(initialMarkers[0]);
  const [zoom, setZoom] = useState(6);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [iconSize, setIconSize] = useState<google.maps.Size | null>(null);

  // Para manejar el estado del InfoWindow abierto
  const [selectedPlace, setSelectedPlace] = useState<any>(null);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setCenter(userLocation);
          setZoom(getZoomLevel(userLocation.lat));
        },
        (error) => {
          console.error("Error al obtener la ubicación:", error);

          // Establecer coordenadas de Colombia como predeterminadas
          setCenter({ lat: 4.5709, lng: -74.2973 });
          setZoom(6); // Configura el nivel de zoom adecuado para mostrar Colombia
        }
      );
    } else {
      console.error("Geolocalización no es compatible con este navegador.");
    }
  }, []);

  useEffect(() => {
    const currentCity = ciudades.find((item: any) => item.ciudad === ciudad);
    setCenter(currentCity?.coordenadas);
    setZoom(currentCity?.zoom);
  }, [ciudad]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setCenter(userLocation);
          setZoom(getZoomLevel(userLocation.lat));
          getCityName(userLocation.lat, userLocation.lng);
        },
        (error) => console.error("Error al obtener la ubicación:", error)
      );
    } else {
      console.error("Geolocalización no es compatible con este navegador.");
    }
  }, [mylocation]);

  const getCityName = (lat: any, lng: any) => {
    const apiKey = "AIzaSyBFIueHL6ufyFll26ee6TfN-qVpSvtp0sw"; // Reemplaza con tu clave de API

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "OK") {
          const addressComponents = data.results[0].address_components;
          const cityComponent = addressComponents.find((component: any) =>
            component.types.includes("locality")
          );
          if (cityComponent) {
            setCiudad(cityComponent.long_name);
          } else {
            console.error("No se encontró la ciudad.");
          }
        } else {
          console.error("Error en la geocodificación:", data.status);
        }
      })
      .catch((error) => console.error("Error al obtener la ciudad:", error));
  };

  const handleIdle = useCallback(() => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter();
      if (newCenter) {
        setCenter((prevCenter) => {
          const newCenterObj = { lat: newCenter.lat(), lng: newCenter.lng() };
          return newCenterObj.lat !== prevCenter.lat ||
            newCenterObj.lng !== prevCenter.lng
            ? newCenterObj
            : prevCenter;
        });
      }
    }
  }, []);

  // Asignar el tamaño del ícono cuando el mapa está listo
  const handleMapLoad = (map: google.maps.Map) => {
    mapRef.current = map;
    if (window.google && window.google.maps) {
      setIconSize(new window.google.maps.Size(40, 40)); // Ajusta el tamaño si es necesario
    }
  };

  const handleMarkerClick = (place: any) => {
    const dataLayerEvent: any = {
      event: "dealer_selected",
      dealer_name: place,
    };

    // Empujar al dataLayer
    if (window.dataLayer) {
      window.dataLayer.push(dataLayerEvent);
    }
    setSelectedPlace(place);
  };

  const handleInfoWindowClose = () => {
    setSelectedPlace(null);
  };

  const containerStyle = {
    width: "100%",
    height: viewportWidth < 900 ? "100%" : "100%",
    borderRadius: "20px",
  };

  return (
    <div className="contenido-mapa-concesionarios-component">
      <LoadScript googleMapsApiKey="AIzaSyBFIueHL6ufyFll26ee6TfN-qVpSvtp0sw">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
          onLoad={handleMapLoad}
          onIdle={handleIdle}
        >
          {selectedConcesionarios?.map((place: any, index: any) => (
            <Marker
              key={index + "-" + place.nombre}
              position={{
                lat: parseFloat(place?.latitude),
                lng: parseFloat(place?.longitude),
              }}
              icon={{
                url: location,
                scaledSize: iconSize, // Solo se asigna cuando iconSize está listo
              }}
              onClick={() => handleMarkerClick(place)}
            />
          ))}

          {selectedPlace && (
            <InfoWindow
              position={{
                lat: parseFloat(selectedPlace?.latitude),
                lng: parseFloat(selectedPlace?.longitude),
              }}
              onCloseClick={handleInfoWindowClose}
            >
              <div className="tooltip-contenido-mapa-concesionarios-component">
                <div className="info-window-header">
                  <span className="info-window-title">
                    {selectedPlace.name}
                  </span>
                </div>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default ContenidoMapaComponent;
